import { ResourceName } from "../../../../core/router/config/ResourceName";
import { baseAuthApi } from "../../../../core/service/baseApi";
import type { LoadVirtualSiteGroupSitesRequest, VirtualSiteGroupSitesResponse } from "./types";

export const virtualSiteGroupSitesApi = baseAuthApi.injectEndpoints({
    endpoints: (builder) => ({
        loadVirtualSiteGroupSites: builder.query<VirtualSiteGroupSitesResponse, LoadVirtualSiteGroupSitesRequest>({
            providesTags: ["mainCache"],
            query: ({ dataGroupCode, virtualSiteGroupId }) => ({
                url: `${ResourceName.DATA_GROUPS}/${dataGroupCode}/${ResourceName.VIRTUAL_SITE_GROUPS}/${virtualSiteGroupId}/${ResourceName.SITES}`,
                method: "GET",
            }),
        }),
    }),
});

export const { useLoadVirtualSiteGroupSitesQuery } = virtualSiteGroupSitesApi;
